import API from './api';

export const submitIBPilotRequest = (payload) =>
  API.post('/auth/ib-pilot-requests/', payload).then((response) => response.data);

export const getIBPilotRequests = ({ search = '', status = '', signal } = {}) =>
  API.get('/auth/platform_admin/ib-pilot-requests/', {
    signal,
    params: {
      ...(search && { search }),
      ...(status && { status }),
    },
  }).then((response) => response.data);

export const updateIBPilotRequest = (uuid, payload) =>
  API.patch(`/auth/platform_admin/ib-pilot-requests/${uuid}/`, payload).then(
    (response) => response.data,
  );
